module.exports = __webpack_public_path__ + "assets/img/qrcode_server.48087f2d.jpg";